import { RTEContent, WidthOptions } from '@/types';
import { Button, RichText, Text } from '@/ui';
import clsx from 'clsx';

import { BlockBase, Wrapper, getBlockWidthClassNames, getMarginClassNames } from './utils';

export function Heading({
  element,
  elementStyle,
  text,
  description,
  id,
  margin,
  actions,
  blockWidth,
}: {
  element: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  elementStyle: 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6';
  text: string;
  description: RTEContent;
  actions: {
    primary: {
      href: string;
      text: string;
    };
  };
  blockWidth: WidthOptions;
} & BlockBase) {
  return (
    <Wrapper
      id={id}
      className={clsx(
        {
          '!justify-center text-center': !actions?.primary,
          '!justify-between text-start': actions?.primary,
        },
        actions?.primary && !description?.content ? 'items-baseline' : 'items-center',
        getMarginClassNames(margin),
        getBlockWidthClassNames(blockWidth, 'standard'),
        'flex w-full flex-col gap-4 sm:flex-row',
      )}
    >
      <div className={clsx('flex flex-col gap-2', { 'items-center': !actions?.primary })}>
        <Text element={element || 'h2'} elementStyle={elementStyle || 'h1'}>
          {text}
        </Text>
        {description?.content && <RichText>{description.content}</RichText>}
      </div>
      {actions?.primary && <Button href={actions.primary.href}>{actions.primary.text}</Button>}
    </Wrapper>
  );
}
